// extracted by mini-css-extract-plugin
export default {"input":"input-module__input__B-ku-"};